import React, {useEffect, useRef, useState} from 'react';
import {useRecoilValue} from 'recoil';
import dayjs from 'dayjs';
import {useNavigate} from 'react-router-dom';

import Layout from '../../../layouts';
import styles from '../styles.module.scss';
import {getCommunityByBrands} from '../../../services/brands';
import {user} from '../../../store/user';
import Fetcher from '../../common/Fetcher';

interface Props {
  groupId: number;
  brandName: string;
}

export default function RecommendCommunity({groupId, brandName}: Props) {
  const accessToken = useRecoilValue(user);
  const navigator = useNavigate();
  const imgRef = useRef<HTMLDivElement>(null);
  // const {height: imgHeight, imageRef} = useImageHeight();
  const [communities, setCommunities] = useState<Community[]>([]);
  const [params, setParams] = useState<CommunityByBrandParam>({
    limit: 20,
    offset: 0,
    brand_group: -1,
  });
  const [height, setHeight] = useState(0);
  const callbackResize = () => {
    if (imgRef.current) {
      const width = imgRef.current.getBoundingClientRect().width;
      setHeight(width);
    }
  };
  const getCommunity = async () => {
    const _params = {...params};
    _params.brand_group = groupId;
    setParams(_params);
    const res = await getCommunityByBrands(accessToken, _params);
    return res.data.results;
  };
  const moveToCommunity = () => {
    navigator('/community?type=brand', {
      state: {
        id: groupId,
        name: brandName,
        prev: location.pathname.replace('/', ''),
      },
      replace: true,
    });
  };
  useEffect(() => {
    if (communities.length > 0) {
      if (imgRef.current) {
        const width = imgRef.current.getBoundingClientRect().width;
        setHeight(width);
      }
    }
    window.addEventListener('resize', callbackResize, false);
    return () => {
      window.removeEventListener('resize', callbackResize, false);
    };
  }, [communities, imgRef]);
  return (
    <div
      style={{
        padding: '0 16px',
        background: '#fff',
        display: communities && communities.length > 0 ? 'block' : 'none',
      }}>
      <Layout.BrandCardView
        title={'추천 커뮤니티 글'}
        titleStyle={{padding: '0'}}
        titleContents={
          <div
            className={styles.more}
            onClick={() => moveToCommunity()}
            style={{
              display: communities && communities.length > 1 ? 'flex' : 'none',
              cursor: 'pointer',
            }}>
            <span>더보기</span>
          </div>
        }
        style={{paddingBottom: '60px'}}>
        <Fetcher fetcher={getCommunity} setter={setCommunities}>
          {communities.length > 0 && (
            <div
              className={styles.communityItem}
              onClick={() => navigator(`/community/${communities[0].id}`)}
              style={{cursor: 'pointer'}}>
              <div className={styles.profiles}>
                <div className={styles.profile}>
                  <div
                    className={styles.pimg}
                    style={{
                      background: communities[0].author.profileImage
                        ? `url(${communities[0].author.profileImage}) no-repeat center / cover`
                        : '',
                    }}></div>
                  <div className={styles.name}>
                    {communities[0].author.nickname}
                  </div>
                </div>
                <div className={styles.date}>
                  {dayjs(communities[0].created).format('YYYY-MM-DD')}
                </div>
              </div>
              <div className={styles.contents}>
                <div className={styles.title}>{communities[0].title}</div>
                <div className={styles.desc}>{communities[0].content}</div>
                <div className={styles.imgs}>
                  {[...communities[0].images.slice(0, 3)].map(o => {
                    return (
                      <div key={o.id} style={{width: '25%'}} ref={imgRef}>
                        <img
                          className={styles.comImg}
                          src={o.image}
                          alt=""
                          style={{height: `${height}px`}}
                        />
                      </div>
                    );
                  })}
                  {communities[0].images.length > 3 && (
                    <div
                      className={styles.moreImg}
                      style={{
                        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${communities[0].images[3].image}) no-repeat center / cover`,
                        height: `${height}px`,
                      }}>
                      <div className={styles.more}>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Fetcher>
      </Layout.BrandCardView>
    </div>
  );
}
